import { render, staticRenderFns } from "./StockFilterButton.vue?vue&type=template&id=1f926c2f&scoped=true&"
import script from "./StockFilterButton.vue?vue&type=script&lang=js&"
export * from "./StockFilterButton.vue?vue&type=script&lang=js&"
import style0 from "./StockFilterButton.vue?vue&type=style&index=0&id=1f926c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f926c2f",
  null
  
)

export default component.exports